import { Component, OnInit, Input ,ViewEncapsulation} from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
 /* template: `
  <div class="modal-header">
      <h4 class="modal-title">Hi there!</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>Hello, {{title}}!</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
    </div>`,*/
  styleUrls: ['./alert.component.css']
})
//
export class AlertComponent {

@Input() title = `Error`;
@Input() mensaje = `Se ha producido un error, por favor comuníquese con el administrador`;
@Input() funcion:any;

constructor(public activeModal: NgbActiveModal) {}

/*
openBackDropCustomClass(content) {
  this.modalService.open(content, {backdropClass: 'light-blue-backdrop'});
}

openWindowCustomClass(content) {
  this.modalService.open(content, { windowClass: 'dark-modal' });
}

openSm(content) {
  this.modalService.open(content, { size: 'sm' });
}

openLg(content) {
  this.modalService.open(content, { size: 'lg' });
}

openVerticallyCentered(content) {
  this.modalService.open(content, { centered: true });
}*/

}
